import _Message from "@mui/icons-material/Message";
import React from 'react';
import { COLORS, FONTS } from '@fupa/fupa-uikit';
import ActivityHeader from 'app/components/district/common/ActivityHeader';
import { IconContainer } from 'app/components/district/common/ActivityStyles';
export default function NewsActivityHeader(_ref) {
  let {
    subject,
    publishDate
  } = _ref;
  return /*#__PURE__*/React.createElement(ActivityHeader, {
    title: "News",
    subject: subject,
    publishDate: publishDate,
    "data-sentry-element": "ActivityHeader",
    "data-sentry-component": "NewsActivityHeader",
    "data-sentry-source-file": "NewsActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.darkGreen,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "NewsActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Message, {
    sx: {
      fontSize: FONTS['20'],
      color: COLORS.white
    },
    "data-sentry-element": "Message",
    "data-sentry-source-file": "NewsActivityHeader.tsx"
  })));
}